<template>
    <modal name="sign-in-modal"
        :adaptive="true"
        :focusTrap="true"
        :width="500"
        height="auto"
        :styles="{ boxShadow: 'none', background: 'transparent' }"
        overlayTransition="overlay"
        @before-close="beforeClose"
    >
        <div class="rounded-lg bg-white px-12 py-12">
            <h2 class="text-center text-2xl text-green-warm-600 pb-8">
                {{ $t('login.login_heading') }}
            </h2>

            <div class="flex flex-col mb-6">
                <div class="h-4 flex items-center justify-between leading-none mb-3">
                    <label class="uppercase text-gray-700 text-xs tracking-wider leading-none">
                        {{ $t('login.email') }}
                    </label>
                </div>

                <input type="email"
                    class="flex-1 field text-lg"
                    name="email"
                    v-model="email"
                    @keyup.enter="submit"
                >
            </div>

            <div class="flex flex-col mb-6">
                <div class="h-4 flex items-center justify-between leading-none mb-3">
                    <label class="uppercase text-gray-700 text-xs tracking-wider">
                        {{ $t('login.password') }}
                    </label>
                </div>

                <input type="password"
                    class="flex-1 field text-lg"
                    name="password"
                    required
                    v-model="password"
                    @keyup.enter="submit"
                >
            </div>

            <a href="/password/reset"
                class="text-medium text-blue-400 hover:text-blue-600 cursor-pointer focus:outline-none focus:shadow-none"
            >
                {{ $t('login.forgot_password') }}
            </a>

            <div class="flex items-center justify-between pt-4">
                <p class="text-red-500 leading-tight mb-0">
                    {{ error }}
                </p>

                <button type="button"
                    class="flex-none uppercase tracking-widest bg-green-warm-600 hover:bg-green-warm-500 text-white text-sm hover:text-white px-12 py-4 rounded-full"
                    @click="submit"
                >
                    {{ $t('login.login_button') }}
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    props: {
        show: {},
    },

    data() {
        return {
            email: null,
            password: null,
            error: null,
        }
    },

    methods: {
        beforeClose(event) {
            this.$emit('closed');
        },
        submit() {
            this.error = null;
            axios.post('/auth/login', {
                email: this.email,
                password: this.password,
                remember: true,
            }).then(response => {
                window.location.replace(response.data.redirect);
            }).catch(error => {
                this.error = this.$t('login.login_error')
            });
        },
    },

    watch: {
        show(val) {
            if (val) {
                this.$modal.show('sign-in-modal');
            } else {
                this.$modal.hide('sign-in-modal');
            }
        },
    },

}
</script>

<style scoped>
.vm--overlay {
    background: #000000;
    opacity: 0.7;
}

.overlay-enter,
.overlay-leave-to {
    opacity: 0;
}

.overlay-enter-active,
.overlay-leave-active {
    transition: all .3s;
}
</style>
